// extracted by mini-css-extract-plugin
module.exports = {"mainListWrapper":"styles_mainListWrapper__UVWwu","heading":"styles_heading__2PPjw","wrapper":"styles_wrapper__TUV_r"};